<script lang="ts" setup>
function reload() {
    window.location.reload();
}
</script>

<template>
    <div class="flex h-screen flex-col items-center justify-center gap-4 p-4 text-center">
        <h1 class="text-2xl font-bold">{{ $t('appUpdate.loadFailed') }}</h1>
        <p class="text-base-content/70 max-w-md">
            {{ $t('appUpdate.loadFailedText') }}
        </p>
        <button
            class="btn btn-primary"
            @click="reload">
            {{ $t('appUpdate.reload') }}
        </button>
    </div>
</template>
